webpackJsonp([2,0],{

/***/ 0:
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _vue = __webpack_require__(12);
	
	var _vue2 = _interopRequireDefault(_vue);
	
	var _store = __webpack_require__(157);
	
	var _store2 = _interopRequireDefault(_store);
	
	var _vueRouter = __webpack_require__(229);
	
	var _vueRouter2 = _interopRequireDefault(_vueRouter);
	
	var _App = __webpack_require__(210);
	
	var _App2 = _interopRequireDefault(_App);
	
	__webpack_require__(153);
	
	var _routerConfig = __webpack_require__(154);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	_vue2.default.use(_vueRouter2.default);
	
	var router = new _vueRouter2.default({
	  routes: _routerConfig.routes,
	  linkActiveClass: 'active',
	  scrollBehavior: function scrollBehavior(to, from, savedPosition) {
	    return { x: 0, y: 0 };
	  },
	
	  mode: 'history'
	});
	
	new _vue2.default({
	  router: router,
	  store: _store2.default,
	  render: function render(h) {
	    return h(_App2.default);
	  }
	}).$mount('#app');

/***/ },

/***/ 18:
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	var SET_AUTH_TOKEN = exports.SET_AUTH_TOKEN = 'SET_AUTH_TOKEN';
	
	var LOAD_QUOTE = exports.LOAD_QUOTE = 'LOAD_QUOTE';
	
	var SET_QUOTE_LOADED = exports.SET_QUOTE_LOADED = 'SET_QUOTE_LOADED';
	
	var UPDATE_QUOTE = exports.UPDATE_QUOTE = 'UPDATE_QUOTE';
	
	var SET_QUOTE_SAVED = exports.SET_QUOTE_SAVED = 'SET_QUOTE_SAVED';
	
	var UPDATE_QUOTE_PARAMS = exports.UPDATE_QUOTE_PARAMS = 'UPDATE_QUOTE_PARAMS';
	
	var UPDATE_OPTIONAL_RATE = exports.UPDATE_OPTIONAL_RATE = 'UPDATE_OPTIONAL_RATE';
	
	var SET_QUOTE_TEMPLATES = exports.SET_QUOTE_TEMPLATES = 'SET_QUOTE_TEMPLATES';
	
	var SET_QUOTE_META = exports.SET_QUOTE_META = 'SET_QUOTE_META';
	
	var SET_FLASH = exports.SET_FLASH = 'SET_FLASH';
	
	var CLEAR_FLASH = exports.CLEAR_FLASH = 'CLEAR_FLASH';

/***/ },

/***/ 133:
/***/ function(module, exports, __webpack_require__) {

	var Component = __webpack_require__(3)(
	  /* script */
	  __webpack_require__(163),
	  /* template */
	  __webpack_require__(223),
	  /* scopeId */
	  null,
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ },

/***/ 153:
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _vue = __webpack_require__(12);
	
	var _vue2 = _interopRequireDefault(_vue);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	_vue2.default.filter('currency', function (value, decimals) {
	  decimals = isNaN(decimals = Math.abs(decimals)) ? 0 : decimals;
	  var i = String(parseInt(value = Math.abs(Number(value) || 0).toFixed(decimals)));
	  var j = (j = i.length) > 3 ? j % 3 : 0;
	  return '$' + (j ? i.substr(0, j) + ',' : '') + i.substr(j).replace(/(\d{3})(?=\d)/g, '$1' + ',') + (decimals ? '.' + Math.abs(value - i).toFixed(decimals).slice(2) : '');
	});
	
	_vue2.default.filter('capitalize', function (value) {
	  return value.charAt(0).toUpperCase() + value.slice(1);
	});

/***/ },

/***/ 154:
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.routes = undefined;
	
	var _New = __webpack_require__(216);
	
	var _New2 = _interopRequireDefault(_New);
	
	var _Edit = __webpack_require__(212);
	
	var _Edit2 = _interopRequireDefault(_Edit);
	
	var _Dashboard = __webpack_require__(211);
	
	var _Dashboard2 = _interopRequireDefault(_Dashboard);
	
	var _Summary = __webpack_require__(218);
	
	var _Summary2 = _interopRequireDefault(_Summary);
	
	var _Editor = __webpack_require__(213);
	
	var _Editor2 = _interopRequireDefault(_Editor);
	
	var _FixedCostItems = __webpack_require__(214);
	
	var _FixedCostItems2 = _interopRequireDefault(_FixedCostItems);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var routes = exports.routes = [{
	  path: '/',
	  redirect: { name: 'dashboard' }
	}, {
	  path: '/new',
	  name: 'new',
	  component: _New2.default
	}, {
	  path: '/edit',
	  name: 'edit',
	  component: _Edit2.default
	}, {
	  path: '/dashboard',
	  name: 'dashboard',
	  component: _Dashboard2.default
	}, {
	  path: '/summary',
	  name: 'summary',
	  component: _Summary2.default
	}, {
	  path: '/editor',
	  name: 'editor',
	  component: _Editor2.default
	}, {
	  path: '/fixed_cost_items',
	  name: 'fixed_cost_items',
	  component: _FixedCostItems2.default
	}, {
	  path: '*',
	  redirect: { name: 'dashboard' }
	}];

/***/ },

/***/ 155:
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.loadQuote = exports.saveNewQuoteVersion = exports.saveQuote = exports.fetchQuoteTemplates = undefined;
	
	var _mutationTypes = __webpack_require__(18);
	
	var types = _interopRequireWildcard(_mutationTypes);
	
	var _axios = __webpack_require__(135);
	
	var _axios2 = _interopRequireDefault(_axios);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	var $http = _axios2.default.create({
	  baseURL: 'https://app.tungstenatom.com/api/v1'
	});
	
	var fetchQuoteTemplates = exports.fetchQuoteTemplates = function fetchQuoteTemplates(_ref) {
	  var commit = _ref.commit,
	      getters = _ref.getters;
	
	  $http.defaults.headers.common['Authorization'] = 'Token token=' + getters.authToken;
	
	  $http.get('/quote_templates').then(function (response) {
	    commit(types.SET_QUOTE_TEMPLATES, { quoteTemplates: response.data });
	  }).catch(function (error) {
	    commit('SET_FLASH', {
	      type: 'error',
	      message: error.message
	    });
	  });
	};
	
	var saveQuote = exports.saveQuote = function saveQuote(_ref2) {
	  var commit = _ref2.commit,
	      getters = _ref2.getters,
	      state = _ref2.state;
	
	  if (getters.isNewQuote) {
	    $http.post('/quotes', state.quote).then(function (response) {
	      commit(types.LOAD_QUOTE, { quote: response.data });
	    }).catch(function (error) {
	      commit('SET_FLASH', {
	        type: 'error',
	        message: error.message
	      });
	    });
	  } else {
	    $http.patch('/quotes/' + state.quote.id, { payload: state.quote.payload }).then(function (response) {
	      commit(types.LOAD_QUOTE, { quote: response.data });
	      commit(types.SET_QUOTE_SAVED);
	    }).catch(function (error) {
	      commit('SET_FLASH', {
	        type: 'error',
	        message: error.message
	      });
	    });
	  }
	};
	
	var saveNewQuoteVersion = exports.saveNewQuoteVersion = function saveNewQuoteVersion(_ref3) {
	  var commit = _ref3.commit,
	      state = _ref3.state;
	
	  $http.post('/quotes', state.quote).then(function (response) {
	    commit(types.LOAD_QUOTE, { quote: response.data });
	    commit(types.SET_FLASH, {
	      type: 'success',
	      message: 'Successfully saved Version ' + response.data.version + ' of the Quote.'
	    });
	    commit(types.SET_QUOTE_SAVED);
	  }).catch(function (error) {
	    commit('SET_FLASH', {
	      type: 'error',
	      message: error.message
	    });
	  });
	};
	
	var loadQuote = exports.loadQuote = function loadQuote(_ref4, quoteId) {
	  var commit = _ref4.commit,
	      getters = _ref4.getters;
	
	  $http.defaults.headers.common['Authorization'] = 'Token token=' + getters.authToken;
	
	  $http.get('/quotes/' + quoteId).then(function (response) {
	    commit(types.LOAD_QUOTE, { quote: response.data });
	    commit(types.SET_QUOTE_LOADED);
	  }).catch(function (error) {
	    commit('SET_FLASH', {
	      type: 'error',
	      message: error.message
	    });
	  });
	};

/***/ },

/***/ 156:
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.quoteLastSaved = exports.flashIsActive = exports.flash = exports.itemTypes = exports.params = exports.aggregates = exports.meta = exports.fetchQuoteTemplates = exports.quoteTemplatesAreNotSet = exports.isNewQuote = exports.quoteHasBeenEdited = exports.quoteIsLoaded = exports.loadQuote = exports.authToken = undefined;
	
	var _extends2 = __webpack_require__(171);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _stringify = __webpack_require__(5);
	
	var _stringify2 = _interopRequireDefault(_stringify);
	
	var _lodash = __webpack_require__(4);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	var _moment = __webpack_require__(1);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var authToken = exports.authToken = function authToken(state) {
	  return state.authToken;
	};
	
	var loadQuote = exports.loadQuote = function loadQuote(state) {
	  return (0, _stringify2.default)(state.quote.payload);
	};
	
	var quoteIsLoaded = exports.quoteIsLoaded = function quoteIsLoaded(state) {
	  return state.flags.quoteIsLoaded;
	};
	
	var quoteHasBeenEdited = exports.quoteHasBeenEdited = function quoteHasBeenEdited(state) {
	  return state.flags.quoteHasBeenEdited;
	};
	
	var isNewQuote = exports.isNewQuote = function isNewQuote(state) {
	  return state.quote.id === 0;
	};
	
	var quoteTemplatesAreNotSet = exports.quoteTemplatesAreNotSet = function quoteTemplatesAreNotSet(state) {
	  return state.quoteTemplates.length === 0;
	};
	
	var fetchQuoteTemplates = exports.fetchQuoteTemplates = function fetchQuoteTemplates(state) {
	  return state.quoteTemplates;
	};
	
	var meta = exports.meta = function meta(state) {
	  return {
	    job_no: state.quote.meta.job_no,
	    version: state.quote.version,
	    customer: state.quote.meta.customer,
	    title: state.quote.meta.title
	  };
	};
	
	var aggregates = exports.aggregates = function aggregates(state) {
	  var quote = state.quote.payload;
	  var pmRatioPercent = quote.pm_ratio / 100;
	
	  var itemTypes = state.itemTypes;
	  var result = {
	    hours: quote.hours,
	    components: []
	  };
	
	  _lodash2.default.forEach(quote.components, function (component) {
	    var pmHours = _lodash2.default.ceil(component.hours * pmRatioPercent);
	    var componentAggregates = {
	      title: component.title,
	      hours: component.hours,
	      pm: pmHours,
	      total_hours: component.hours + pmHours,
	      sections: []
	    };
	
	    _lodash2.default.forEach(itemTypes, function (itemType) {
	      componentAggregates[itemType.value] = 0;
	      _lodash2.default.forEach(component.sections, function (section) {
	        var sectionPmHours = _lodash2.default.ceil(section.hours * pmRatioPercent);
	        componentAggregates.sections.push({
	          title: section.title,
	          hours: section.hours,
	          pm: sectionPmHours,
	          total_hours: section.hours + sectionPmHours
	        });
	
	        _lodash2.default.forEach(section.items, function (item) {
	          if (item.type === itemType.value) componentAggregates[itemType.value] += parseInt(item.hours);
	        });
	      });
	    });
	
	    componentAggregates.sections = _lodash2.default.uniqBy(componentAggregates.sections, 'title');
	
	    result.components.push(componentAggregates);
	  });
	
	  result['pm'] = _lodash2.default.sumBy(result.components, function (o) {
	    return o.pm;
	  });
	  result['total_hours'] = result.hours + result.pm;
	  if (typeof quote.fixed_cost_items !== 'undefined') {
	    result['fixed_cost_items'] = quote.fixed_cost_items.items;
	    result['fixed_cost_items_amount'] = quote.fixed_cost_items.amount;
	  }
	
	  return result;
	};
	
	var params = exports.params = function params(state) {
	  return (0, _extends3.default)({
	    rate: state.quote.payload.rate,
	    pmRatio: state.quote.payload.pm_ratio,
	    showHosting: state.quote.payload.show_hosting
	  }, state.options);
	};
	
	var itemTypes = exports.itemTypes = function itemTypes(state) {
	  return state.itemTypes;
	};
	
	var flash = exports.flash = function flash(state) {
	  return state.flash;
	};
	
	var flashIsActive = exports.flashIsActive = function flashIsActive(state) {
	  return state.flash.active;
	};
	
	var quoteLastSaved = exports.quoteLastSaved = function quoteLastSaved(state) {
	  if (_lodash2.default.isEmpty(state.quote.updated_at)) {
	    return 'Never';
	  } else {
	    return (0, _moment2.default)(state.quote.updated_at).format('M/D/YY h:mma');
	  }
	};

/***/ },

/***/ 157:
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _defineProperty2 = __webpack_require__(170);
	
	var _defineProperty3 = _interopRequireDefault(_defineProperty2);
	
	var _mutations;
	
	var _vue = __webpack_require__(12);
	
	var _vue2 = _interopRequireDefault(_vue);
	
	var _vuex = __webpack_require__(231);
	
	var _vuex2 = _interopRequireDefault(_vuex);
	
	var _mutationTypes = __webpack_require__(18);
	
	var types = _interopRequireWildcard(_mutationTypes);
	
	var _actions = __webpack_require__(155);
	
	var actions = _interopRequireWildcard(_actions);
	
	var _getters = __webpack_require__(156);
	
	var getters = _interopRequireWildcard(_getters);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	_vue2.default.use(_vuex2.default);
	
	exports.default = new _vuex2.default.Store({
	  state: {
	    flash: {
	      active: false,
	      type: '',
	      message: ''
	    },
	
	    flags: {
	      quoteIsLoaded: false,
	      quoteHasBeenEdited: false
	    },
	
	    quote: {
	      id: 0,
	      project_id: 0,
	      version: 1,
	      payload: {},
	      meta: {}
	    },
	
	    options: {
	      optionalRate: 115,
	      newlineRate: 75,
	      hostingBase: 10,
	      hostingRatio: 0.75,
	      supportBase: 20,
	      supportRatio: 0.75
	    },
	
	    itemTypes: [{ value: 'des', label: 'Design', abbr: 'Design' }, { value: 'dev', label: 'Development', abbr: 'Dev' }, { value: 'sdv', label: 'Standard Development', abbr: 'Std.Dev' }, { value: 'oth', label: 'Other', abbr: 'Other' }],
	
	    authToken: '',
	
	    quoteTemplates: []
	  },
	
	  mutations: (_mutations = {}, (0, _defineProperty3.default)(_mutations, types.SET_AUTH_TOKEN, function (state, payload) {
	    state.authToken = payload;
	  }), (0, _defineProperty3.default)(_mutations, types.LOAD_QUOTE, function (state, payload) {
	    state.quote = payload.quote;
	    if (typeof state.quote.payload.fixed_cost_items === 'undefined') {
	      console.log('Adding fixed_cost_items...');
	      state.quote.payload.fixed_cost_items = { amount: 0, items: [] };
	    }
	    state.flags.quoteHasBeenEdited = false;
	  }), (0, _defineProperty3.default)(_mutations, types.SET_QUOTE_LOADED, function (state) {
	    state.flags.quoteIsLoaded = true;
	  }), (0, _defineProperty3.default)(_mutations, types.UPDATE_QUOTE, function (state, payload) {
	    state.quote.payload = JSON.parse(payload.payload);
	    if (typeof state.quote.payload.fixed_cost_items === 'undefined') {
	      state.quote.payload.fixed_cost_items = { amount: 0, items: [] };
	    }
	    state.flags.quoteHasBeenEdited = true;
	  }), (0, _defineProperty3.default)(_mutations, types.SET_QUOTE_SAVED, function (state) {
	    state.flags.quoteHasBeenEdited = false;
	  }), (0, _defineProperty3.default)(_mutations, types.UPDATE_QUOTE_PARAMS, function (state, payload) {
	    state.quote.payload.rate = payload.rate;
	    state.quote.payload.pm_ratio = payload.pmRatio;
	    state.quote.payload.show_hosting = payload.showHosting;
	    state.flags.quoteHasBeenEdited = true;
	  }), (0, _defineProperty3.default)(_mutations, types.UPDATE_OPTIONAL_RATE, function (state, payload) {
	    state.options.optionalRate = payload;
	  }), (0, _defineProperty3.default)(_mutations, types.SET_QUOTE_TEMPLATES, function (state, payload) {
	    state.quoteTemplates = payload.quoteTemplates;
	  }), (0, _defineProperty3.default)(_mutations, types.SET_QUOTE_META, function (state, payload) {
	    state.quote.project_id = payload.project_id;
	    state.quote.meta = {
	      job_no: payload.job_no,
	      customer: payload.customer,
	      title: payload.title
	    };
	  }), (0, _defineProperty3.default)(_mutations, types.SET_FLASH, function (state, payload) {
	    state.flash.active = true;
	    state.flash.type = payload.type;
	    state.flash.message = payload.message;
	  }), (0, _defineProperty3.default)(_mutations, types.CLEAR_FLASH, function (state) {
	    state.flash.active = false;
	  }), _mutations),
	
	  actions: actions,
	  getters: getters,
	  strict: true
	});

/***/ },

/***/ 158:
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = {
	  computed: {
	    quoteAggregates: function quoteAggregates() {
	      return this.$store.getters.aggregates;
	    },
	    quoteIsLoaded: function quoteIsLoaded() {
	      return this.$store.getters.quoteIsLoaded;
	    },
	    quoteLastSaved: function quoteLastSaved() {
	      return this.$store.getters.quoteLastSaved;
	    },
	    quoteHasBeenEdited: function quoteHasBeenEdited() {
	      return this.$store.getters.quoteHasBeenEdited;
	    },
	    quoteMeta: function quoteMeta() {
	      return this.$store.getters.meta;
	    },
	    flash: function flash() {
	      return this.$store.getters.flash;
	    },
	    flashIsActive: function flashIsActive() {
	      return this.$store.getters.flashIsActive;
	    }
	  },
	
	  watch: {
	    flashIsActive: function flashIsActive() {
	      if (this.flashIsActive) {
	        window.$('header .masthead .dimmer').dimmer({ closable: false }).dimmer('show');
	      } else {
	        window.$('header .masthead .dimmer').dimmer('hide');
	      }
	    }
	  },
	
	  methods: {
	    saveQuote: function saveQuote() {
	      this.$store.dispatch('saveQuote');
	    },
	    saveNewQuoteVersion: function saveNewQuoteVersion() {
	      this.$store.dispatch('saveNewQuoteVersion');
	    },
	    clearFlash: function clearFlash() {
	      this.$store.commit('CLEAR_FLASH');
	    }
	  },
	
	  mounted: function mounted() {
	    window.$('#save-new-version').dropdown({ on: 'hover', action: 'hide' });
	  },
	  updated: function updated() {
	    window.$('#save-new-version').dropdown({ on: 'hover', action: 'hide' });
	  }
	};

/***/ },

/***/ 159:
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _lodash = __webpack_require__(4);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  data: function data() {
	    return {
	      quoteParams: {},
	      quoteAggregates: {},
	      includedComponents: [],
	      fixedCostItemsAmount: 0
	    };
	  },
	
	
	  computed: {
	    hostingRatioPercent: function hostingRatioPercent() {
	      return this.quoteParams.hostingRatio / 100;
	    },
	    supportRatioPercent: function supportRatioPercent() {
	      return this.quoteParams.supportRatio / 100;
	    },
	    totalDevHours: function totalDevHours() {
	      return this.componentsSumBy('dev');
	    },
	    totalHostingAmount: function totalHostingAmount() {
	      return _lodash2.default.ceil(this.totalDevHours * this.quoteParams.newlineRate * this.hostingRatioPercent + this.quoteParams.hostingBase);
	    },
	    totalSupportAmount: function totalSupportAmount() {
	      return _lodash2.default.ceil(this.totalDevHours * this.quoteParams.newlineRate * this.supportRatioPercent + this.quoteParams.supportBase);
	    },
	    totalMonthlyServicesAmount: function totalMonthlyServicesAmount() {
	      return this.totalHostingAmount + this.totalSupportAmount;
	    }
	  },
	
	  methods: {
	    initDashboard: function initDashboard() {
	      this.quoteParams = this.$store.getters.params;
	      this.quoteAggregates = this.$store.getters.aggregates;
	      this.includedComponents = _lodash2.default.map(this.quoteAggregates.components, 'title');
	      this.fixedCostItemsAmount = this.quoteAggregates.fixed_cost_items_amount;
	    },
	    currentComponentClass: function currentComponentClass(title) {
	      if (_lodash2.default.includes(this.includedComponents, title)) {
	        return '';
	      } else {
	        return 'not-included';
	      }
	    },
	    toggleComponent: function toggleComponent(title) {
	      if (_lodash2.default.includes(this.includedComponents, title)) {
	        var index = this.includedComponents.indexOf(title);
	        this.includedComponents.splice(index, 1);
	      } else {
	        this.includedComponents.push(title);
	      }
	    },
	    componentsSumBy: function componentsSumBy(cat) {
	      var hours = 0;
	      var included = this.includedComponents;
	      var available = this.quoteAggregates.components;
	      _lodash2.default.forEach(included, function (o) {
	        _lodash2.default.forEach(available, function (c) {
	          if (o === c.title) {
	            hours += parseInt(c[cat]);
	          }
	        });
	      });
	      return hours;
	    },
	    toggleShowHosting: function toggleShowHosting() {
	      this.quoteParams.showHosting = !this.quoteParams.showHosting;
	      this.updateQuoteParams();
	    },
	    updatePmRatio: function updatePmRatio() {
	      this.updateQuoteParams();
	      this.quoteAggregates = this.$store.getters.aggregates;
	    },
	    updateQuoteParams: function updateQuoteParams() {
	      this.$store.commit('UPDATE_QUOTE_PARAMS', {
	        rate: this.quoteParams.rate,
	        pmRatio: this.quoteParams.pmRatio,
	        showHosting: this.quoteParams.showHosting
	      });
	    },
	    updateOptionalRate: function updateOptionalRate() {
	      this.$store.commit('UPDATE_OPTIONAL_RATE', this.quoteParams.optionalRate);
	    }
	  },
	
	  created: function created() {
	    if (this.$store.getters.quoteIsLoaded) {
	      this.initDashboard();
	    } else {
	      this.$router.replace({ name: 'new' });
	    }
	  },
	  mounted: function mounted() {
	    window.$('.ui.checkbox').checkbox();
	  },
	  updated: function updated() {
	    window.$('.ui.checkbox').checkbox();
	  }
	};

/***/ },

/***/ 160:
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _lodash = __webpack_require__(4);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  computed: {
	    quoteIsLoaded: function quoteIsLoaded() {
	      return this.$store.getters.quoteIsLoaded;
	    },
	    flash: function flash() {
	      return this.$store.getters.flash;
	    },
	    flashIsActive: function flashIsActive() {
	      return this.$store.getters.flashIsActive;
	    }
	  },
	
	  watch: {
	    quoteIsLoaded: function quoteIsLoaded() {
	      if (this.quoteIsLoaded) {
	        this.$router.push({ name: 'dashboard' });
	      }
	    }
	  },
	
	  methods: {
	    loadQuote: function loadQuote() {
	      if (!_lodash2.default.isEmpty(this.$route.query.id)) {
	        var quoteId = this.$route.query.id;
	        this.$store.commit('SET_AUTH_TOKEN', this.$route.query.auth_token);
	        this.$store.dispatch('loadQuote', quoteId);
	      } else {
	        this.$store.commit('SET_FLASH', {
	          type: 'error',
	          message: 'Unable to load the quote because the Quote ID is missing...'
	        });
	      }
	    }
	  },
	
	  mounted: function mounted() {
	    this.loadQuote();
	  }
	};

/***/ },

/***/ 161:
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _stringify = __webpack_require__(5);
	
	var _stringify2 = _interopRequireDefault(_stringify);
	
	var _ModalConfirm = __webpack_require__(133);
	
	var _ModalConfirm2 = _interopRequireDefault(_ModalConfirm);
	
	var _ModalReorder = __webpack_require__(215);
	
	var _ModalReorder2 = _interopRequireDefault(_ModalReorder);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  data: function data() {
	    return {
	      quote: {},
	      confirmPayload: {},
	      reorderPayload: {}
	    };
	  },
	
	
	  components: {
	    ModalConfirm: _ModalConfirm2.default,
	    ModalReorder: _ModalReorder2.default
	  },
	
	  computed: {
	    quoteIsLoaded: function quoteIsLoaded() {
	      return this.$store.getters.quoteIsLoaded;
	    },
	    itemTypes: function itemTypes() {
	      return this.$store.getters.itemTypes;
	    }
	  },
	
	  methods: {
	    updateQuote: function updateQuote() {
	      this.$store.commit('UPDATE_QUOTE', { payload: (0, _stringify2.default)(this.quote) });
	    },
	    addComponent: function addComponent() {
	      var newComponent = { title: 'New Component', hours: 0, sections: [] };
	      this.addSection(newComponent);
	      this.quote.components.push(newComponent);
	      this.updateQuote();
	    },
	    addSection: function addSection(component) {
	      var newSection = { title: 'New Section', hours: 0, items: [] };
	      this.addItem(newSection);
	      component.sections.push(newSection);
	      this.updateQuote();
	    },
	    addItem: function addItem(section) {
	      var newItem = { title: 'New Item', type: 'des', hours: 0 };
	      section.items.push(newItem);
	      this.updateQuote();
	    },
	    confirmComponentRemoval: function confirmComponentRemoval(component) {
	      this.confirmPayload = {
	        message: 'Are you sure you want to remove the <strong>' + component.title + '</strong> component and all it\'s contents?',
	        target: 'component',
	        component: component
	      };
	      window.$('#modal-confirm').modal('setting', 'closable', false).modal('show');
	    },
	    confirmSectionRemoval: function confirmSectionRemoval(component, section) {
	      this.confirmPayload = {
	        message: 'Are you sure you want to remove the <strong>' + section.title + '</strong> section and all it\'s contents from the <strong>' + component.title + '</strong> component?',
	        target: 'section',
	        component: component,
	        section: section
	      };
	      window.$('#modal-confirm').modal('setting', 'closable', false).modal('show');
	    },
	    confirmItemRemoval: function confirmItemRemoval(component, section, item) {
	      this.confirmPayload = {
	        message: 'Are you sure you want to remove the <strong>' + item.title + '</strong> item?',
	        target: 'item',
	        component: component,
	        section: section,
	        item: item
	      };
	      window.$('#modal-confirm').modal('setting', 'closable', false).modal('show');
	    },
	    remove: function remove(confirmed) {
	      if (confirmed) {
	        var payload = this.confirmPayload;
	        switch (payload.target) {
	          case 'component':
	            {
	              var component = payload.component;
	              var index = this.quote.components.indexOf(component);
	              this.quote.components.splice(index, 1);
	              this.calcQuoteHours();
	              break;
	            }
	          case 'section':
	            {
	              var _component = payload.component;
	              var section = payload.section;
	              var _index = _component.sections.indexOf(section);
	              _component.sections.splice(_index, 1);
	              this.calcComponentHours(_component);
	              break;
	            }
	          case 'item':
	            {
	              var _component2 = payload.component;
	              var _section = payload.section;
	              var item = payload.item;
	              var _index2 = _section.items.indexOf(item);
	              _section.items.splice(_index2, 1);
	              this.calcSectionHours(_component2, _section);
	              break;
	            }
	        }
	        this.updateQuote();
	      } else {
	        this.confirmPayload = {};
	      }
	    },
	    reorder: function reorder(options) {
	      this.reorderPayload = options;
	      window.$('#modal-reorder').modal('setting', 'closable', false).modal('show');
	    },
	    reorderCleanup: function reorderCleanup() {
	      this.reorderPayload = {};
	    },
	    calcSectionHours: function calcSectionHours(component, section) {
	      var total = 0;
	      section.items.forEach(function (item) {
	        var hours = isNaN(parseInt(item.hours)) ? 0 : parseInt(item.hours);
	        total += hours;
	      });
	      section.hours = total;
	      this.calcComponentHours(component);
	    },
	    calcComponentHours: function calcComponentHours(component) {
	      var total = 0;
	      component.sections.forEach(function (section) {
	        total += parseInt(section.hours);
	      });
	      component.hours = total;
	      this.calcQuoteHours();
	    },
	    calcQuoteHours: function calcQuoteHours() {
	      var total = 0;
	      this.quote.components.forEach(function (component) {
	        total += parseInt(component.hours);
	      });
	      this.quote.hours = total;
	      this.updateQuote();
	    }
	  },
	
	  created: function created() {
	    if (this.$store.getters.quoteIsLoaded) {
	      this.quote = JSON.parse(this.$store.getters.loadQuote);
	    } else {
	      console.log('Quote not yet loaded. Redirecting...');
	      this.$router.replace({ name: 'new' });
	    }
	    console.log('Quote is new: ' + this.$store.getters.isNewQuote);
	  },
	  mounted: function mounted() {
	    window.$('select.ui.dropdown').dropdown();
	  },
	  updated: function updated() {
	    window.$('select.ui.dropdown').dropdown();
	  },
	  destroyed: function destroyed() {
	    window.$('.ui.dimmer.modals.page.transition.hidden').remove();
	  }
	};

/***/ },

/***/ 162:
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _stringify = __webpack_require__(5);
	
	var _stringify2 = _interopRequireDefault(_stringify);
	
	var _lodash = __webpack_require__(4);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	var _ModalConfirm = __webpack_require__(133);
	
	var _ModalConfirm2 = _interopRequireDefault(_ModalConfirm);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  data: function data() {
	    return {
	      quote: {},
	      confirmPayload: {}
	    };
	  },
	
	
	  components: {
	    ModalConfirm: _ModalConfirm2.default
	  },
	
	  computed: {
	    quoteIsLoaded: function quoteIsLoaded() {
	      return this.$store.getters.quoteIsLoaded;
	    }
	  },
	
	  methods: {
	    updateQuote: function updateQuote() {
	      this.$store.commit('UPDATE_QUOTE', { payload: (0, _stringify2.default)(this.quote) });
	    },
	    addItem: function addItem() {
	      var newItem = { title: 'New Item', amount: 0 };
	      this.quote.fixed_cost_items.items.push(newItem);
	      this.updateQuote();
	    },
	    calcTotalAmount: function calcTotalAmount() {
	      this.quote.fixed_cost_items.amount = _lodash2.default.sumBy(this.quote.fixed_cost_items.items, 'amount');
	      this.updateQuote();
	    },
	    confirmItemRemoval: function confirmItemRemoval(item) {
	      this.confirmPayload = {
	        message: 'Are you sure you want to remove the <strong>' + item.title + '</strong> item?',
	        target: 'item',
	        item: item
	      };
	      window.$('#modal-confirm').modal('setting', 'closable', false).modal('show');
	    },
	    remove: function remove(confirmed) {
	      if (confirmed) {
	        var payload = this.confirmPayload;
	        switch (payload.target) {
	          case 'item':
	            {
	              var item = payload.item;
	              var index = this.quote.fixed_cost_items.items.indexOf(item);
	              this.quote.fixed_cost_items.items.splice(index, 1);
	              this.calcTotalAmount();
	              break;
	            }
	        }
	      } else {
	        this.confirmPayload = {};
	      }
	    }
	  },
	
	  created: function created() {
	    if (this.$store.getters.quoteIsLoaded) {
	      this.quote = JSON.parse(this.$store.getters.loadQuote);
	    } else {
	      console.log('Quote not yet loaded. Redirecting...');
	      this.$router.replace({ name: 'new' });
	    }
	  }
	};

/***/ },

/***/ 163:
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = {
	  props: ['payload'],
	
	  methods: {
	    confirm: function confirm(result) {
	      this.$emit('confirm', result);
	      window.$('#modal-confirm').modal('hide');
	    }
	  }
	};

/***/ },

/***/ 164:
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _vuedraggable = __webpack_require__(230);
	
	var _vuedraggable2 = _interopRequireDefault(_vuedraggable);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  props: ['payload'],
	
	  components: {
	    draggable: _vuedraggable2.default
	  },
	
	  methods: {
	    reorder: function reorder() {
	      this.$emit('reorder');
	    },
	    close: function close() {
	      this.$emit('close');
	      window.$('#modal-confirm').modal('hide');
	    }
	  }
	};

/***/ },

/***/ 165:
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _stringify = __webpack_require__(5);
	
	var _stringify2 = _interopRequireDefault(_stringify);
	
	var _lodash = __webpack_require__(4);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  computed: {
	    quoteTemplates: function quoteTemplates() {
	      return this.$store.getters.fetchQuoteTemplates;
	    },
	    flash: function flash() {
	      return this.$store.getters.flash;
	    },
	    flashIsActive: function flashIsActive() {
	      return this.$store.getters.flashIsActive;
	    }
	  },
	
	  methods: {
	    setQuoteMeta: function setQuoteMeta() {
	      if (!_lodash2.default.isEmpty(this.$route.query)) {
	        this.$store.commit('SET_QUOTE_META', this.$route.query);
	        this.$store.commit('SET_AUTH_TOKEN', this.$route.query.auth_token);
	        if (this.$store.getters.quoteTemplatesAreNotSet) {
	          this.$store.dispatch('fetchQuoteTemplates');
	        }
	      } else {
	        this.$store.commit('SET_FLASH', {
	          type: 'error',
	          message: 'The quote meta parameters are missing...'
	        });
	      }
	    },
	    loadQuote: function loadQuote(quoteTemplate) {
	      var payload = JSON.parse((0, _stringify2.default)(quoteTemplate.payload));
	      this.$store.commit('UPDATE_QUOTE', { payload: (0, _stringify2.default)(payload) });
	      this.$store.commit('SET_QUOTE_LOADED');
	      this.$router.push({ name: 'dashboard' });
	    }
	  },
	
	  mounted: function mounted() {
	    this.setQuoteMeta();
	  }
	};

/***/ },

/***/ 166:
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _lodash = __webpack_require__(4);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  data: function data() {
	    return {};
	  },
	
	
	  props: ['component', 'quote-params'],
	
	  computed: {
	    totalHours: function totalHours() {
	      return this.component.hours + this.pmHours;
	    },
	    pmHours: function pmHours() {
	      return this.calcPmHours(this.component.hours);
	    },
	    pmRatioPercent: function pmRatioPercent() {
	      return this.quoteParams.pmRatio / 100;
	    },
	    itemTypes: function itemTypes() {
	      return this.$store.getters.itemTypes;
	    }
	  },
	
	  methods: {
	    calcPmHours: function calcPmHours(hours) {
	      return _lodash2.default.ceil(hours * this.pmRatioPercent);
	    },
	
	    sectionTotalHours: function sectionTotalHours(section) {
	      return section.hours + this.calcPmHours(section.hours);
	    }
	  }
	};

/***/ },

/***/ 167:
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _lodash = __webpack_require__(4);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	var _QuoteComponent = __webpack_require__(217);
	
	var _QuoteComponent2 = _interopRequireDefault(_QuoteComponent);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  data: function data() {
	    return {
	      quoteParams: {},
	      quoteAggregates: {}
	    };
	  },
	
	
	  components: {
	    QuoteComponent: _QuoteComponent2.default
	  },
	
	  methods: {
	    initSummary: function initSummary() {
	      this.quoteParams = this.$store.getters.params;
	      this.quoteAggregates = this.$store.getters.aggregates;
	    },
	    componentAggregates: function componentAggregates(title) {
	      return _lodash2.default.find(this.quoteAggregates.components, ['title', title]);
	    }
	  },
	
	  created: function created() {
	    if (this.$store.getters.quoteIsLoaded) {
	      this.initSummary();
	    } else {
	      console.log('Quote not yet loaded. Redirecting...');
	      this.$router.replace({ name: 'new' });
	    }
	  }
	};

/***/ },

/***/ 200:
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ },

/***/ 201:
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ },

/***/ 202:
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ },

/***/ 203:
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ },

/***/ 204:
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ },

/***/ 205:
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ },

/***/ 206:
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ },

/***/ 207:
/***/ function(module, exports, __webpack_require__) {

	var map = {
		"./af": 25,
		"./af.js": 25,
		"./ar": 31,
		"./ar-dz": 26,
		"./ar-dz.js": 26,
		"./ar-ly": 27,
		"./ar-ly.js": 27,
		"./ar-ma": 28,
		"./ar-ma.js": 28,
		"./ar-sa": 29,
		"./ar-sa.js": 29,
		"./ar-tn": 30,
		"./ar-tn.js": 30,
		"./ar.js": 31,
		"./az": 32,
		"./az.js": 32,
		"./be": 33,
		"./be.js": 33,
		"./bg": 34,
		"./bg.js": 34,
		"./bn": 35,
		"./bn.js": 35,
		"./bo": 36,
		"./bo.js": 36,
		"./br": 37,
		"./br.js": 37,
		"./bs": 38,
		"./bs.js": 38,
		"./ca": 39,
		"./ca.js": 39,
		"./cs": 40,
		"./cs.js": 40,
		"./cv": 41,
		"./cv.js": 41,
		"./cy": 42,
		"./cy.js": 42,
		"./da": 43,
		"./da.js": 43,
		"./de": 45,
		"./de-at": 44,
		"./de-at.js": 44,
		"./de.js": 45,
		"./dv": 46,
		"./dv.js": 46,
		"./el": 47,
		"./el.js": 47,
		"./en-au": 48,
		"./en-au.js": 48,
		"./en-ca": 49,
		"./en-ca.js": 49,
		"./en-gb": 50,
		"./en-gb.js": 50,
		"./en-ie": 51,
		"./en-ie.js": 51,
		"./en-nz": 52,
		"./en-nz.js": 52,
		"./eo": 53,
		"./eo.js": 53,
		"./es": 55,
		"./es-do": 54,
		"./es-do.js": 54,
		"./es.js": 55,
		"./et": 56,
		"./et.js": 56,
		"./eu": 57,
		"./eu.js": 57,
		"./fa": 58,
		"./fa.js": 58,
		"./fi": 59,
		"./fi.js": 59,
		"./fo": 60,
		"./fo.js": 60,
		"./fr": 63,
		"./fr-ca": 61,
		"./fr-ca.js": 61,
		"./fr-ch": 62,
		"./fr-ch.js": 62,
		"./fr.js": 63,
		"./fy": 64,
		"./fy.js": 64,
		"./gd": 65,
		"./gd.js": 65,
		"./gl": 66,
		"./gl.js": 66,
		"./he": 67,
		"./he.js": 67,
		"./hi": 68,
		"./hi.js": 68,
		"./hr": 69,
		"./hr.js": 69,
		"./hu": 70,
		"./hu.js": 70,
		"./hy-am": 71,
		"./hy-am.js": 71,
		"./id": 72,
		"./id.js": 72,
		"./is": 73,
		"./is.js": 73,
		"./it": 74,
		"./it.js": 74,
		"./ja": 75,
		"./ja.js": 75,
		"./jv": 76,
		"./jv.js": 76,
		"./ka": 77,
		"./ka.js": 77,
		"./kk": 78,
		"./kk.js": 78,
		"./km": 79,
		"./km.js": 79,
		"./ko": 80,
		"./ko.js": 80,
		"./ky": 81,
		"./ky.js": 81,
		"./lb": 82,
		"./lb.js": 82,
		"./lo": 83,
		"./lo.js": 83,
		"./lt": 84,
		"./lt.js": 84,
		"./lv": 85,
		"./lv.js": 85,
		"./me": 86,
		"./me.js": 86,
		"./mi": 87,
		"./mi.js": 87,
		"./mk": 88,
		"./mk.js": 88,
		"./ml": 89,
		"./ml.js": 89,
		"./mr": 90,
		"./mr.js": 90,
		"./ms": 92,
		"./ms-my": 91,
		"./ms-my.js": 91,
		"./ms.js": 92,
		"./my": 93,
		"./my.js": 93,
		"./nb": 94,
		"./nb.js": 94,
		"./ne": 95,
		"./ne.js": 95,
		"./nl": 97,
		"./nl-be": 96,
		"./nl-be.js": 96,
		"./nl.js": 97,
		"./nn": 98,
		"./nn.js": 98,
		"./pa-in": 99,
		"./pa-in.js": 99,
		"./pl": 100,
		"./pl.js": 100,
		"./pt": 102,
		"./pt-br": 101,
		"./pt-br.js": 101,
		"./pt.js": 102,
		"./ro": 103,
		"./ro.js": 103,
		"./ru": 104,
		"./ru.js": 104,
		"./se": 105,
		"./se.js": 105,
		"./si": 106,
		"./si.js": 106,
		"./sk": 107,
		"./sk.js": 107,
		"./sl": 108,
		"./sl.js": 108,
		"./sq": 109,
		"./sq.js": 109,
		"./sr": 111,
		"./sr-cyrl": 110,
		"./sr-cyrl.js": 110,
		"./sr.js": 111,
		"./ss": 112,
		"./ss.js": 112,
		"./sv": 113,
		"./sv.js": 113,
		"./sw": 114,
		"./sw.js": 114,
		"./ta": 115,
		"./ta.js": 115,
		"./te": 116,
		"./te.js": 116,
		"./tet": 117,
		"./tet.js": 117,
		"./th": 118,
		"./th.js": 118,
		"./tl-ph": 119,
		"./tl-ph.js": 119,
		"./tlh": 120,
		"./tlh.js": 120,
		"./tr": 121,
		"./tr.js": 121,
		"./tzl": 122,
		"./tzl.js": 122,
		"./tzm": 124,
		"./tzm-latn": 123,
		"./tzm-latn.js": 123,
		"./tzm.js": 124,
		"./uk": 125,
		"./uk.js": 125,
		"./uz": 126,
		"./uz.js": 126,
		"./vi": 127,
		"./vi.js": 127,
		"./x-pseudo": 128,
		"./x-pseudo.js": 128,
		"./yo": 129,
		"./yo.js": 129,
		"./zh-cn": 130,
		"./zh-cn.js": 130,
		"./zh-hk": 131,
		"./zh-hk.js": 131,
		"./zh-tw": 132,
		"./zh-tw.js": 132
	};
	function webpackContext(req) {
		return __webpack_require__(webpackContextResolve(req));
	};
	function webpackContextResolve(req) {
		return map[req] || (function() { throw new Error("Cannot find module '" + req + "'.") }());
	};
	webpackContext.keys = function webpackContextKeys() {
		return Object.keys(map);
	};
	webpackContext.resolve = webpackContextResolve;
	module.exports = webpackContext;
	webpackContext.id = 207;


/***/ },

/***/ 210:
/***/ function(module, exports, __webpack_require__) {

	
	/* styles */
	__webpack_require__(200)
	
	var Component = __webpack_require__(3)(
	  /* script */
	  __webpack_require__(158),
	  /* template */
	  __webpack_require__(219),
	  /* scopeId */
	  null,
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ },

/***/ 211:
/***/ function(module, exports, __webpack_require__) {

	
	/* styles */
	__webpack_require__(206)
	
	var Component = __webpack_require__(3)(
	  /* script */
	  __webpack_require__(159),
	  /* template */
	  __webpack_require__(228),
	  /* scopeId */
	  "data-v-faf071ac",
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ },

/***/ 212:
/***/ function(module, exports, __webpack_require__) {

	var Component = __webpack_require__(3)(
	  /* script */
	  __webpack_require__(160),
	  /* template */
	  __webpack_require__(224),
	  /* scopeId */
	  null,
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ },

/***/ 213:
/***/ function(module, exports, __webpack_require__) {

	
	/* styles */
	__webpack_require__(204)
	
	var Component = __webpack_require__(3)(
	  /* script */
	  __webpack_require__(161),
	  /* template */
	  __webpack_require__(226),
	  /* scopeId */
	  "data-v-ee511b72",
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ },

/***/ 214:
/***/ function(module, exports, __webpack_require__) {

	
	/* styles */
	__webpack_require__(201)
	
	var Component = __webpack_require__(3)(
	  /* script */
	  __webpack_require__(162),
	  /* template */
	  __webpack_require__(220),
	  /* scopeId */
	  "data-v-3ba23e8e",
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ },

/***/ 215:
/***/ function(module, exports, __webpack_require__) {

	
	/* styles */
	__webpack_require__(202)
	
	var Component = __webpack_require__(3)(
	  /* script */
	  __webpack_require__(164),
	  /* template */
	  __webpack_require__(221),
	  /* scopeId */
	  "data-v-4a2c5068",
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ },

/***/ 216:
/***/ function(module, exports, __webpack_require__) {

	var Component = __webpack_require__(3)(
	  /* script */
	  __webpack_require__(165),
	  /* template */
	  __webpack_require__(222),
	  /* scopeId */
	  null,
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ },

/***/ 217:
/***/ function(module, exports, __webpack_require__) {

	
	/* styles */
	__webpack_require__(203)
	
	var Component = __webpack_require__(3)(
	  /* script */
	  __webpack_require__(166),
	  /* template */
	  __webpack_require__(225),
	  /* scopeId */
	  "data-v-cbb6c28a",
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ },

/***/ 218:
/***/ function(module, exports, __webpack_require__) {

	
	/* styles */
	__webpack_require__(205)
	
	var Component = __webpack_require__(3)(
	  /* script */
	  __webpack_require__(167),
	  /* template */
	  __webpack_require__(227),
	  /* scopeId */
	  "data-v-ee68da88",
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ },

/***/ 219:
/***/ function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    attrs: {
	      "id": "app"
	    }
	  }, [(_vm.quoteIsLoaded) ? _c('div', [_c('header', [_c('div', {
	    staticClass: "masthead"
	  }, [_c('div', {
	    staticClass: "ui grid"
	  }, [_c('div', {
	    staticClass: "ten wide column"
	  }, [_c('h1', {
	    staticClass: "ui header"
	  }, [_c('div', {
	    staticClass: "sub header"
	  }, [_c('strong', [_vm._v(_vm._s(_vm.quoteMeta.job_no))]), _vm._v("\n                |\n                Version: " + _vm._s(_vm.quoteMeta.version) + "\n              ")]), _vm._v("\n              " + _vm._s(_vm.quoteMeta.title) + "\n              "), _c('div', {
	    staticClass: "sub header"
	  }, [_vm._v("\n                " + _vm._s(_vm.quoteMeta.customer) + "\n              ")])])]), _vm._v(" "), _c('div', {
	    staticClass: "six wide right aligned column"
	  }, [_c('div', {
	    staticClass: "ui tiny grey statistic"
	  }, [_c('div', {
	    staticClass: "value"
	  }, [_vm._v("\n                " + _vm._s(_vm.quoteAggregates.hours) + "\n              ")]), _vm._v(" "), _c('div', {
	    staticClass: "label"
	  }, [_vm._v("\n                Hours\n              ")])]), _vm._v(" "), _vm._m(0), _vm._v(" "), _c('div', {
	    staticClass: "ui tiny grey statistic"
	  }, [_c('div', {
	    staticClass: "value"
	  }, [_vm._v("\n                " + _vm._s(_vm.quoteAggregates.pm) + "\n              ")]), _vm._v(" "), _c('div', {
	    staticClass: "label"
	  }, [_vm._v("\n                PM\n              ")])]), _vm._v(" "), _vm._m(1), _vm._v(" "), _c('div', {
	    staticClass: "ui tiny statistic"
	  }, [_c('div', {
	    staticClass: "value"
	  }, [_vm._v("\n                " + _vm._s(_vm.quoteAggregates.total_hours) + "\n              ")]), _vm._v(" "), _c('div', {
	    staticClass: "label"
	  }, [_vm._v("\n                Total\n              ")])])])]), _vm._v(" "), _c('div', {
	    staticClass: "ui dimmer"
	  }, [_c('div', {
	    staticClass: "content"
	  }, [_c('div', {
	    staticClass: "center"
	  }, [_c('div', {
	    staticClass: "ui message",
	    class: _vm.flash.type
	  }, [_c('i', {
	    staticClass: "close icon",
	    on: {
	      "click": _vm.clearFlash
	    }
	  }), _vm._v(" "), _c('div', {
	    staticClass: "header"
	  }, [_vm._v("\n                  " + _vm._s(_vm._f("capitalize")(_vm.flash.type)) + "\n                ")]), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.flash.message))])])])])])]), _vm._v(" "), _c('div', {
	    staticClass: "ui top menu"
	  }, [_c('router-link', {
	    staticClass: "item",
	    attrs: {
	      "to": {
	        name: 'dashboard'
	      }
	    }
	  }, [_vm._v("Dashboard")]), _vm._v(" "), (_vm.quoteIsLoaded) ? _c('router-link', {
	    staticClass: "item",
	    attrs: {
	      "to": {
	        name: 'summary'
	      }
	    }
	  }, [_vm._v("Summary")]) : _vm._e(), _vm._v(" "), (_vm.quoteIsLoaded) ? _c('router-link', {
	    staticClass: "item",
	    attrs: {
	      "to": {
	        name: 'editor'
	      }
	    }
	  }, [_vm._v("Editor")]) : _vm._e(), _vm._v(" "), (_vm.quoteIsLoaded) ? _c('router-link', {
	    staticClass: "item",
	    attrs: {
	      "to": {
	        name: 'fixed_cost_items'
	      }
	    }
	  }, [_vm._v("Fixed Cost Items")]) : _vm._e(), _vm._v(" "), (_vm.quoteIsLoaded) ? _c('div', {
	    staticClass: "ui right menu"
	  }, [_c('div', {
	    staticClass: "item darken-on-hover"
	  }, [_vm._v("\n            Last saved: " + _vm._s(_vm.quoteLastSaved) + "\n          ")]), _vm._v(" "), (_vm.quoteHasBeenEdited) ? _c('a', {
	    staticClass: "item save-quote",
	    attrs: {
	      "href": "#"
	    },
	    on: {
	      "click": function($event) {
	        $event.preventDefault();
	        _vm.saveQuote($event)
	      }
	    }
	  }, [_vm._v("Save")]) : _c('div', {
	    staticClass: "item save-quote"
	  }, [_vm._v("Saved")]), _vm._v(" "), _c('div', {
	    staticClass: "ui dropdown item",
	    attrs: {
	      "id": "save-new-version"
	    }
	  }, [_c('i', {
	    staticClass: "dropdown icon"
	  }), _vm._v(" "), _c('div', {
	    staticClass: "menu"
	  }, [_c('div', {
	    staticClass: "link item",
	    on: {
	      "click": _vm.saveNewQuoteVersion
	    }
	  }, [_vm._v("Save New Version")])])])]) : _vm._e()], 1)])]) : _vm._e(), _vm._v(" "), _c('router-view')], 1)
	},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "ui tiny grey statistic"
	  }, [_c('div', {
	    staticClass: "value"
	  }, [_vm._v("\n                +\n              ")])])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "ui tiny grey statistic"
	  }, [_c('div', {
	    staticClass: "value"
	  }, [_vm._v("\n                =\n              ")])])
	}]}

/***/ },

/***/ 220:
/***/ function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "ui container view"
	  }, [_c('table', {
	    staticClass: "section ui celled table"
	  }, [_vm._m(0), _vm._v(" "), _c('tbody', [_vm._l((_vm.quote.fixed_cost_items.items), function(item) {
	    return _c('tr', {
	      staticClass: "item"
	    }, [_c('td', {
	      staticClass: "description"
	    }, [_c('div', {
	      staticClass: "ui transparent input"
	    }, [_c('input', {
	      directives: [{
	        name: "model",
	        rawName: "v-model",
	        value: (item.title),
	        expression: "item.title"
	      }],
	      attrs: {
	        "type": "text"
	      },
	      domProps: {
	        "value": _vm._s(item.title)
	      },
	      on: {
	        "input": function($event) {
	          if ($event.target.composing) { return; }
	          item.title = $event.target.value
	        }
	      }
	    })])]), _vm._v(" "), _c('td', {
	      staticClass: "amount"
	    }, [_c('div', {
	      staticClass: "ui transparent input"
	    }, [_vm._v("\n            $"), _c('input', {
	      directives: [{
	        name: "model",
	        rawName: "v-model.number",
	        value: (item.amount),
	        expression: "item.amount",
	        modifiers: {
	          "number": true
	        }
	      }],
	      attrs: {
	        "type": "text"
	      },
	      domProps: {
	        "value": _vm._s(item.amount)
	      },
	      on: {
	        "change": _vm.calcTotalAmount,
	        "input": function($event) {
	          if ($event.target.composing) { return; }
	          item.amount = _vm._n($event.target.value)
	        },
	        "blur": function($event) {
	          _vm.$forceUpdate()
	        }
	      }
	    })])]), _vm._v(" "), _c('td', {
	      staticClass: "controls"
	    }, [_c('a', {
	      attrs: {
	        "href": "#",
	        "title": "Delete Item"
	      },
	      on: {
	        "click": function($event) {
	          $event.preventDefault();
	          _vm.confirmItemRemoval(item)
	        }
	      }
	    }, [_c('i', {
	      staticClass: "red remove link icon"
	    })])])])
	  }), _vm._v(" "), _c('tr', [_vm._m(1), _vm._v(" "), _c('td', {
	    staticClass: "amount"
	  }, [_c('strong', [_vm._v(_vm._s(_vm._f("currency")(_vm.quote.fixed_cost_items.amount)))])]), _vm._v(" "), _c('td', {
	    staticClass: "controls"
	  }, [_c('a', {
	    attrs: {
	      "href": "#",
	      "title": "Add Item"
	    },
	    on: {
	      "click": function($event) {
	        $event.preventDefault();
	        _vm.addItem($event)
	      }
	    }
	  }, [_c('i', {
	    staticClass: "green plus link icon"
	  })])])])], 2)]), _vm._v(" "), _c('modal-confirm', {
	    attrs: {
	      "payload": _vm.confirmPayload
	    },
	    on: {
	      "confirm": _vm.remove
	    }
	  })], 1)
	},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('thead', [_c('tr', [_c('th', {
	    staticClass: "title",
	    attrs: {
	      "colspan": "3"
	    }
	  }, [_vm._v("\n          Fixed Cost Items\n        ")])])])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('td', {
	    staticClass: "description"
	  }, [_c('strong', [_vm._v("Total")])])
	}]}

/***/ },

/***/ 221:
/***/ function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "ui small modal",
	    attrs: {
	      "id": "modal-reorder"
	    }
	  }, [_c('div', {
	    staticClass: "header"
	  }, [_vm._v("\n    Reorder " + _vm._s(_vm.payload.target) + " in " + _vm._s(_vm.payload.title) + "\n  ")]), _vm._v(" "), _c('div', {
	    staticClass: "content"
	  }, [_c('div', {
	    staticClass: "ui fluid vertical menu"
	  }, [_c('draggable', {
	    attrs: {
	      "list": _vm.payload.items
	    },
	    on: {
	      "end": _vm.reorder
	    }
	  }, _vm._l((_vm.payload.items), function(item) {
	    return _c('div', {
	      staticClass: "item"
	    }, [_vm._v("\n          " + _vm._s(item.title) + "\n        ")])
	  }))], 1)]), _vm._v(" "), _c('div', {
	    staticClass: "actions"
	  }, [_c('button', {
	    staticClass: "ui positive button",
	    on: {
	      "click": _vm.close
	    }
	  }, [_vm._v("Done")])])])
	},staticRenderFns: []}

/***/ },

/***/ 222:
/***/ function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "ui container view"
	  }, [_c('div', {
	    staticClass: "ui two column centered grid"
	  }, [_c('div', {
	    staticClass: "column"
	  }, [_c('div', {
	    staticClass: "ui raised segment"
	  }, [_c('h3', [_vm._v("Create a New Quote")]), _vm._v(" "), (_vm.flashIsActive) ? _c('div', {
	    staticClass: "ui message",
	    class: _vm.flash.type
	  }, [_c('div', {
	    staticClass: "header"
	  }, [_vm._v("\n            " + _vm._s(_vm._f("capitalize")(_vm.flash.type)) + "\n          ")]), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.flash.message))])]) : _c('div', [_c('p', [_vm._v("Use one of the templates below as a starting point for your new quote.")]), _vm._v(" "), _c('div', {
	    staticClass: "ui divider"
	  }), _vm._v(" "), _c('div', {
	    staticClass: "ui relaxed divided selection list"
	  }, _vm._l((_vm.quoteTemplates), function(quoteTemplate) {
	    return _c('a', {
	      staticClass: "item",
	      on: {
	        "click": function($event) {
	          _vm.loadQuote(quoteTemplate)
	        }
	      }
	    }, [_c('i', {
	      staticClass: "large file text middle aligned icon"
	    }), _vm._v(" "), _c('div', {
	      staticClass: "content"
	    }, [_c('div', {
	      staticClass: "ui tiny blue header"
	    }, [_vm._v(_vm._s(quoteTemplate.title))]), _vm._v(" "), _c('div', {
	      staticClass: "description"
	    }, [_vm._v(_vm._s(quoteTemplate.description))])])])
	  }))])])])])])
	},staticRenderFns: []}

/***/ },

/***/ 223:
/***/ function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "ui small modal",
	    attrs: {
	      "id": "modal-confirm"
	    }
	  }, [_c('div', {
	    staticClass: "header"
	  }, [_vm._v("\n    Please confirm...\n  ")]), _vm._v(" "), _c('div', {
	    staticClass: "content",
	    domProps: {
	      "innerHTML": _vm._s(_vm.payload.message)
	    }
	  }), _vm._v(" "), _c('div', {
	    staticClass: "actions"
	  }, [_c('button', {
	    staticClass: "ui button",
	    on: {
	      "click": function($event) {
	        _vm.confirm(false)
	      }
	    }
	  }, [_vm._v("Cancel")]), _vm._v(" "), _c('button', {
	    staticClass: "ui positive button",
	    on: {
	      "click": function($event) {
	        _vm.confirm(true)
	      }
	    }
	  }, [_vm._v("Yes")])])])
	},staticRenderFns: []}

/***/ },

/***/ 224:
/***/ function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "ui container view"
	  }, [_c('div', {
	    staticClass: "ui two column centered grid"
	  }, [_c('div', {
	    staticClass: "column"
	  }, [_c('div', {
	    staticClass: "ui raised segment"
	  }, [(_vm.flashIsActive) ? _c('div', {
	    staticClass: "ui message",
	    class: _vm.flash.type
	  }, [_c('div', {
	    staticClass: "header"
	  }, [_vm._v("\n            " + _vm._s(_vm._f("capitalize")(_vm.flash.type)) + "\n          ")]), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.flash.message))])]) : _c('div', {
	    staticClass: "ui icon message"
	  }, [_c('i', {
	    staticClass: "notched circle loading icon"
	  }), _vm._v(" "), _c('div', {
	    staticClass: "content"
	  }, [_c('div', {
	    staticClass: "header"
	  }, [_vm._v("\n              Just one second\n            ")]), _vm._v(" "), _c('p', [_vm._v("Loading the quote for you right now...")])])])])])])])
	},staticRenderFns: []}

/***/ },

/***/ 225:
/***/ function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('tbody', [_c('tr', {
	    staticClass: "component"
	  }, [_c('td', {
	    staticClass: "title"
	  }, [_vm._v(_vm._s(_vm.component.title))]), _vm._v(" "), _c('td', {
	    staticClass: "hours",
	    attrs: {
	      "colspan": "2"
	    }
	  }, [_vm._v(_vm._s(_vm.totalHours))]), _vm._v(" "), _c('td', {
	    staticClass: "amount",
	    attrs: {
	      "colspan": "2"
	    }
	  }, [_vm._v(_vm._s(_vm._f("currency")(_vm.totalHours * _vm.quoteParams.rate)))]), _vm._v(" "), _c('td', {
	    staticClass: "amount",
	    attrs: {
	      "colspan": "2"
	    }
	  }, [_vm._v(_vm._s(_vm._f("currency")(_vm.totalHours * _vm.quoteParams.optionalRate)))])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("Project Management")]), _vm._v(" "), _c('td', {
	    staticClass: "hours",
	    attrs: {
	      "colspan": "2"
	    }
	  }, [_vm._v(_vm._s(_vm.pmHours))]), _vm._v(" "), _c('td', {
	    staticClass: "amount",
	    attrs: {
	      "colspan": "2"
	    }
	  }, [_vm._v(_vm._s(_vm._f("currency")(_vm.pmHours * _vm.quoteParams.rate)))]), _vm._v(" "), _c('td', {
	    staticClass: "amount",
	    attrs: {
	      "colspan": "2"
	    }
	  }, [_vm._v(_vm._s(_vm._f("currency")(_vm.pmHours * _vm.quoteParams.optionalRate)))])]), _vm._v(" "), _vm._l((_vm.itemTypes), function(itemType) {
	    return (_vm.component[itemType.value] > 0) ? _c('tr', [_c('td', [_vm._v(_vm._s(itemType.label))]), _vm._v(" "), _c('td', {
	      staticClass: "hours",
	      attrs: {
	        "colspan": "2"
	      }
	    }, [_vm._v(_vm._s(_vm.component[itemType.value]))]), _vm._v(" "), _c('td', {
	      staticClass: "amount",
	      attrs: {
	        "colspan": "2"
	      }
	    }, [_vm._v(_vm._s(_vm._f("currency")(_vm.component[itemType.value] * _vm.quoteParams.rate)))]), _vm._v(" "), _c('td', {
	      staticClass: "amount",
	      attrs: {
	        "colspan": "2"
	      }
	    }, [_vm._v(_vm._s(_vm._f("currency")(_vm.component[itemType.value] * _vm.quoteParams.optionalRate)))])]) : _vm._e()
	  }), _vm._v(" "), _vm._m(0), _vm._v(" "), _vm._l((_vm.component.sections), function(section) {
	    return [_c('tr', [_c('td', [_vm._v(_vm._s(section.title))]), _vm._v(" "), _c('td', {
	      staticClass: "hours"
	    }, [_vm._v(_vm._s(_vm.sectionTotalHours(section)))]), _vm._v(" "), _c('td', {
	      staticClass: "hours pm"
	    }, [_vm._v(_vm._s(_vm.calcPmHours(section.hours)))]), _vm._v(" "), _c('td', {
	      staticClass: "amount"
	    }, [_vm._v(_vm._s(_vm._f("currency")(_vm.sectionTotalHours(section) * _vm.quoteParams.rate)))]), _vm._v(" "), _c('td', {
	      staticClass: "amount pm"
	    }, [_vm._v(_vm._s(_vm._f("currency")(_vm.calcPmHours(section.hours) * _vm.quoteParams.rate)))]), _vm._v(" "), _c('td', {
	      staticClass: "amount"
	    }, [_vm._v(_vm._s(_vm._f("currency")(_vm.sectionTotalHours(section) * _vm.quoteParams.optionalRate)))]), _vm._v(" "), _c('td', {
	      staticClass: "amount pm"
	    }, [_vm._v(_vm._s(_vm._f("currency")(_vm.calcPmHours(section.hours) * _vm.quoteParams.optionalRate)))])])]
	  })], 2)
	},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('tr', {
	    staticClass: "section"
	  }, [_c('td', [_c('strong', [_vm._v("Sections")])]), _vm._v(" "), _c('td', {
	    staticClass: "center aligned"
	  }, [_vm._v("Total")]), _vm._v(" "), _c('td', {
	    staticClass: "center aligned"
	  }, [_vm._v("PM")]), _vm._v(" "), _c('td', {
	    staticClass: "center aligned"
	  }, [_vm._v("Total")]), _vm._v(" "), _c('td', {
	    staticClass: "center aligned"
	  }, [_vm._v("PM")]), _vm._v(" "), _c('td', {
	    staticClass: "center aligned"
	  }, [_vm._v("Total")]), _vm._v(" "), _c('td', {
	    staticClass: "center aligned"
	  }, [_vm._v("PM")])])
	}]}

/***/ },

/***/ 226:
/***/ function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "ui container view"
	  }, [_vm._l((_vm.quote.components), function(component) {
	    return _c('div', {
	      staticClass: "ui raised clearing segment component"
	    }, [_c('a', {
	      staticClass: "delete control",
	      attrs: {
	        "href": "#",
	        "title": "Delete Component"
	      },
	      on: {
	        "click": function($event) {
	          $event.preventDefault();
	          _vm.confirmComponentRemoval(component)
	        }
	      }
	    }, [_c('i', {
	      staticClass: "large red remove link icon"
	    })]), _vm._v(" "), _c('a', {
	      staticClass: "reorder control",
	      attrs: {
	        "href": "#",
	        "title": "Reorder Sections"
	      },
	      on: {
	        "click": function($event) {
	          $event.preventDefault();
	          _vm.reorder({
	            target: 'sections',
	            title: component.title,
	            items: component.sections
	          })
	        }
	      }
	    }, [_c('i', {
	      staticClass: "large sort link icon"
	    })]), _vm._v(" "), _c('h2', [_c('span', {
	      staticClass: "ui big blue circular label"
	    }, [_vm._v(_vm._s(component.hours))]), _vm._v(" "), _c('div', {
	      staticClass: "ui transparent input"
	    }, [_c('input', {
	      directives: [{
	        name: "model",
	        rawName: "v-model",
	        value: (component.title),
	        expression: "component.title"
	      }],
	      attrs: {
	        "type": "text"
	      },
	      domProps: {
	        "value": _vm._s(component.title)
	      },
	      on: {
	        "change": _vm.updateQuote,
	        "input": function($event) {
	          if ($event.target.composing) { return; }
	          component.title = $event.target.value
	        }
	      }
	    })])]), _vm._v(" "), _vm._l((component.sections), function(section) {
	      return _c('table', {
	        staticClass: "section ui celled table"
	      }, [_c('thead', [_c('tr', [_c('th', {
	        staticClass: "title",
	        attrs: {
	          "colspan": "2"
	        }
	      }, [_c('div', {
	        staticClass: "ui transparent input"
	      }, [_c('input', {
	        directives: [{
	          name: "model",
	          rawName: "v-model",
	          value: (section.title),
	          expression: "section.title"
	        }],
	        attrs: {
	          "type": "text"
	        },
	        domProps: {
	          "value": _vm._s(section.title)
	        },
	        on: {
	          "change": _vm.updateQuote,
	          "input": function($event) {
	            if ($event.target.composing) { return; }
	            section.title = $event.target.value
	          }
	        }
	      })])]), _vm._v(" "), _c('th', {
	        staticClass: "controls"
	      }, [_c('a', {
	        attrs: {
	          "href": "#",
	          "title": "Reorder Items"
	        },
	        on: {
	          "click": function($event) {
	            $event.preventDefault();
	            _vm.reorder({
	              target: 'items',
	              title: section.title,
	              items: section.items
	            })
	          }
	        }
	      }, [_c('i', {
	        staticClass: "sort link icon"
	      })])]), _vm._v(" "), _c('th', {
	        staticClass: "controls"
	      }, [_c('a', {
	        attrs: {
	          "href": "#",
	          "title": "Delete Section"
	        },
	        on: {
	          "click": function($event) {
	            $event.preventDefault();
	            _vm.confirmSectionRemoval(component, section)
	          }
	        }
	      }, [_c('i', {
	        staticClass: "red remove link icon"
	      })])])])]), _vm._v(" "), _c('tbody', [_vm._l((section.items), function(item) {
	        return _c('tr', {
	          staticClass: "item"
	        }, [_c('td', {
	          staticClass: "description"
	        }, [_c('div', {
	          staticClass: "ui transparent input"
	        }, [_c('input', {
	          directives: [{
	            name: "model",
	            rawName: "v-model",
	            value: (item.title),
	            expression: "item.title"
	          }],
	          attrs: {
	            "type": "text"
	          },
	          domProps: {
	            "value": _vm._s(item.title)
	          },
	          on: {
	            "change": _vm.updateQuote,
	            "input": function($event) {
	              if ($event.target.composing) { return; }
	              item.title = $event.target.value
	            }
	          }
	        })])]), _vm._v(" "), _c('td', {
	          staticClass: "type"
	        }, [_c('select', {
	          directives: [{
	            name: "model",
	            rawName: "v-model",
	            value: (item.type),
	            expression: "item.type"
	          }],
	          staticClass: "ui fluid dropdown",
	          on: {
	            "change": [function($event) {
	              item.type = Array.prototype.filter.call($event.target.options, function(o) {
	                return o.selected
	              }).map(function(o) {
	                var val = "_value" in o ? o._value : o.value;
	                return val
	              })[0]
	            }, _vm.updateQuote]
	          }
	        }, _vm._l((_vm.itemTypes), function(itemType) {
	          return _c('option', {
	            domProps: {
	              "value": itemType.value
	            }
	          }, [_vm._v("\n                " + _vm._s(itemType.abbr) + "\n              ")])
	        }))]), _vm._v(" "), _c('td', {
	          staticClass: "hours"
	        }, [_c('div', {
	          staticClass: "ui transparent input"
	        }, [_c('input', {
	          directives: [{
	            name: "model",
	            rawName: "v-model.number",
	            value: (item.hours),
	            expression: "item.hours",
	            modifiers: {
	              "number": true
	            }
	          }],
	          attrs: {
	            "type": "text"
	          },
	          domProps: {
	            "value": _vm._s(item.hours)
	          },
	          on: {
	            "change": function($event) {
	              _vm.calcSectionHours(component, section)
	            },
	            "input": function($event) {
	              if ($event.target.composing) { return; }
	              item.hours = _vm._n($event.target.value)
	            },
	            "blur": function($event) {
	              _vm.$forceUpdate()
	            }
	          }
	        })])]), _vm._v(" "), _c('td', {
	          staticClass: "controls"
	        }, [_c('a', {
	          attrs: {
	            "href": "#",
	            "title": "Delete Item"
	          },
	          on: {
	            "click": function($event) {
	              $event.preventDefault();
	              _vm.confirmItemRemoval(component, section, item)
	            }
	          }
	        }, [_c('i', {
	          staticClass: "red remove link icon"
	        })])])])
	      }), _vm._v(" "), _c('tr', [_c('td', {
	        staticClass: "description",
	        attrs: {
	          "colspan": "2"
	        }
	      }), _vm._v(" "), _c('td', {
	        staticClass: "hours"
	      }, [_c('strong', [_vm._v(_vm._s(section.hours))])]), _vm._v(" "), _c('td', {
	        staticClass: "controls"
	      }, [_c('a', {
	        attrs: {
	          "href": "#",
	          "title": "Add Item"
	        },
	        on: {
	          "click": function($event) {
	            $event.preventDefault();
	            _vm.addItem(section)
	          }
	        }
	      }, [_c('i', {
	        staticClass: "green plus link icon"
	      })])])])], 2)])
	    }), _vm._v(" "), _c('button', {
	      staticClass: "mini ui green right floated labeled icon button",
	      on: {
	        "click": function($event) {
	          _vm.addSection(component)
	        }
	      }
	    }, [_c('i', {
	      staticClass: "plus icon"
	    }), _vm._v("\n      SECTION\n    ")])], 2)
	  }), _vm._v(" "), _c('button', {
	    staticClass: "mini ui blue labeled icon button",
	    attrs: {
	      "title": "Reorder Components"
	    },
	    on: {
	      "click": function($event) {
	        _vm.reorder({
	          target: 'components',
	          title: 'Quote',
	          items: _vm.quote.components
	        })
	      }
	    }
	  }, [_c('i', {
	    staticClass: "sort icon"
	  }), _vm._v("\n    COMPONENTS\n  ")]), _vm._v(" "), _c('button', {
	    staticClass: "mini ui blue labeled icon button",
	    attrs: {
	      "title": "Add Component"
	    },
	    on: {
	      "click": _vm.addComponent
	    }
	  }, [_c('i', {
	    staticClass: "plus icon"
	  }), _vm._v("\n    COMPONENT\n  ")]), _vm._v(" "), _c('modal-confirm', {
	    attrs: {
	      "payload": _vm.confirmPayload
	    },
	    on: {
	      "confirm": _vm.remove
	    }
	  }), _vm._v(" "), _c('modal-reorder', {
	    attrs: {
	      "payload": _vm.reorderPayload
	    },
	    on: {
	      "reorder": _vm.updateQuote,
	      "close": _vm.reorderCleanup
	    }
	  })], 2)
	},staticRenderFns: []}

/***/ },

/***/ 227:
/***/ function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "ui container view"
	  }, [_c('div', {
	    staticClass: "ui vertically divided grid"
	  }, [_c('div', {
	    staticClass: "two column row"
	  }, [_c('div', {
	    staticClass: "ten wide column"
	  }, [_c('table', {
	    staticClass: "ui compact celled table"
	  }, [_vm._m(0), _vm._v(" "), _vm._l((_vm.quoteAggregates.components), function(component) {
	    return _c('quote-component', {
	      attrs: {
	        "component": component,
	        "quote-params": _vm.quoteParams
	      }
	    })
	  })], 2)]), _vm._v(" "), _c('div', {
	    staticClass: "six wide column"
	  }, [_c('table', {
	    staticClass: "ui compact celled table"
	  }, [_vm._m(1), _vm._v(" "), _c('tbody', _vm._l((_vm.quoteAggregates.fixed_cost_items), function(item) {
	    return _c('tr', [_c('td', [_vm._v(_vm._s(item.title))]), _vm._v(" "), _c('td', {
	      staticClass: "right aligned"
	    }, [_vm._v(_vm._s(_vm._f("currency")(item.amount)))])])
	  })), _vm._v(" "), _c('tfoot', [_c('tr', {
	    staticClass: "total"
	  }, [_c('th', [_vm._v("Total")]), _vm._v(" "), _c('th', {
	    staticClass: "right aligned"
	  }, [_vm._v(_vm._s(_vm._f("currency")(_vm.quoteAggregates.fixed_cost_items_amount)))])])])], 1)])])])])
	},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('thead', [_c('th', {
	    attrs: {
	      "colspan": "7"
	    }
	  }, [_vm._v("Estimate Components")])])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('thead', [_c('th', {
	    attrs: {
	      "colspan": "2"
	    }
	  }, [_vm._v("Fixed Cost Items")])])
	}]}

/***/ },

/***/ 228:
/***/ function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "ui container view"
	  }, [_c('div', {
	    staticClass: "ui grid"
	  }, [_c('div', {
	    staticClass: "two column row"
	  }, [_c('div', {
	    staticClass: "ten wide column"
	  }, [_c('table', {
	    staticClass: "ui celled definition table"
	  }, [_vm._m(0), _vm._v(" "), _c('tbody', _vm._l((_vm.quoteAggregates.components), function(component) {
	    return _c('tr', {
	      class: _vm.currentComponentClass(component.title)
	    }, [_c('td', {
	      staticClass: "collapsing"
	    }, [_c('div', {
	      staticClass: "ui fitted toggle checkbox"
	    }, [_c('input', {
	      staticClass: "hidden",
	      attrs: {
	        "type": "checkbox",
	        "checked": "checked",
	        "tabindex": "0"
	      },
	      on: {
	        "change": function($event) {
	          _vm.toggleComponent(component.title)
	        }
	      }
	    })])]), _vm._v(" "), _c('td', {
	      staticClass: "title"
	    }, [_c('strong', [_vm._v(_vm._s(component.title))])]), _vm._v(" "), _c('td', {
	      staticClass: "hours"
	    }, [_vm._v(_vm._s(component.total_hours))]), _vm._v(" "), _c('td', {
	      staticClass: "amount"
	    }, [_vm._v(_vm._s(_vm._f("currency")(component.total_hours * _vm.quoteParams.rate)))]), _vm._v(" "), _c('td', {
	      staticClass: "amount"
	    }, [_vm._v(_vm._s(_vm._f("currency")(component.total_hours * _vm.quoteParams.optionalRate)))])])
	  })), _vm._v(" "), _c('tfoot', [_c('tr', [_c('th'), _vm._v(" "), _c('th', {
	    staticClass: "title"
	  }, [_vm._v("Subtotal")]), _vm._v(" "), _c('th', {
	    staticClass: "hours"
	  }, [_vm._v(_vm._s(_vm.componentsSumBy('hours')))]), _vm._v(" "), _c('th', {
	    staticClass: "amount"
	  }, [_vm._v(_vm._s(_vm._f("currency")(_vm.componentsSumBy('hours') * _vm.quoteParams.rate)))]), _vm._v(" "), _c('th', {
	    staticClass: "amount"
	  }, [_vm._v(_vm._s(_vm._f("currency")(_vm.componentsSumBy('hours') * _vm.quoteParams.optionalRate)))])]), _vm._v(" "), _c('tr', [_c('th', {
	    staticClass: "empty"
	  }), _vm._v(" "), _c('th', {
	    staticClass: "title"
	  }, [_vm._v("Project Management")]), _vm._v(" "), _c('th', {
	    staticClass: "hours"
	  }, [_vm._v(_vm._s(_vm.componentsSumBy('pm')))]), _vm._v(" "), _c('th', {
	    staticClass: "amount"
	  }, [_vm._v(_vm._s(_vm._f("currency")(_vm.componentsSumBy('pm') * _vm.quoteParams.rate)))]), _vm._v(" "), _c('th', {
	    staticClass: "amount"
	  }, [_vm._v(_vm._s(_vm._f("currency")(_vm.componentsSumBy('pm') * _vm.quoteParams.optionalRate)))])]), _vm._v(" "), _c('tr', [_c('th', {
	    staticClass: "empty"
	  }), _vm._v(" "), _c('th', {
	    staticClass: "title",
	    attrs: {
	      "colspan": "2"
	    }
	  }, [_vm._v("Fixed Cost Items")]), _vm._v(" "), _c('th', {
	    staticClass: "amount"
	  }, [_vm._v(_vm._s(_vm._f("currency")(_vm.fixedCostItemsAmount)))]), _vm._v(" "), _c('th', {
	    staticClass: "amount"
	  }, [_vm._v(_vm._s(_vm._f("currency")(_vm.fixedCostItemsAmount)))])]), _vm._v(" "), _c('tr', {
	    staticClass: "total"
	  }, [_c('th', {
	    staticClass: "empty"
	  }), _vm._v(" "), _c('th', {
	    staticClass: "title"
	  }, [_vm._v("Total")]), _vm._v(" "), _c('th', {
	    staticClass: "hours"
	  }, [_vm._v(_vm._s(_vm.componentsSumBy('total_hours')))]), _vm._v(" "), _c('th', {
	    staticClass: "amount"
	  }, [_vm._v(_vm._s(_vm._f("currency")((_vm.componentsSumBy('total_hours') * _vm.quoteParams.rate) + _vm.fixedCostItemsAmount)))]), _vm._v(" "), _c('th', {
	    staticClass: "amount"
	  }, [_vm._v(_vm._s(_vm._f("currency")((_vm.componentsSumBy('total_hours') * _vm.quoteParams.optionalRate) + _vm.fixedCostItemsAmount)))])])])], 1), _vm._v(" "), _c('table', {
	    directives: [{
	      name: "show",
	      rawName: "v-show",
	      value: (_vm.quoteParams.showHosting),
	      expression: "quoteParams.showHosting"
	    }],
	    staticClass: "ui blue celled table"
	  }, [_vm._m(1), _vm._v(" "), _c('tbody', [_c('tr', [_c('td', {
	    staticClass: "title"
	  }, [_vm._v("Hosting")]), _vm._v(" "), _c('td', {
	    staticClass: "hours"
	  }, [_vm._v(_vm._s(_vm.totalDevHours) + " hrs × " + _vm._s(_vm._f("currency")(_vm.quoteParams.newlineRate)) + " × " + _vm._s(_vm.quoteParams.hostingRatio) + "% + " + _vm._s(_vm._f("currency")(_vm.quoteParams.hostingBase)))]), _vm._v(" "), _c('td', {
	    staticClass: "amount"
	  }, [_vm._v(_vm._s(_vm._f("currency")(_vm.totalHostingAmount)))])]), _vm._v(" "), _c('tr', [_c('td', {
	    staticClass: "title"
	  }, [_vm._v("Support")]), _vm._v(" "), _c('td', {
	    staticClass: "hours"
	  }, [_vm._v(_vm._s(_vm.totalDevHours) + " hrs × " + _vm._s(_vm._f("currency")(_vm.quoteParams.newlineRate)) + " × " + _vm._s(_vm.quoteParams.supportRatio) + "% + " + _vm._s(_vm._f("currency")(_vm.quoteParams.supportBase)))]), _vm._v(" "), _c('td', {
	    staticClass: "amount"
	  }, [_vm._v(_vm._s(_vm._f("currency")(_vm.totalSupportAmount)))])])]), _vm._v(" "), _c('tfoot', [_c('tr', {
	    staticClass: "total"
	  }, [_c('th', {
	    staticClass: "title",
	    attrs: {
	      "colspan": "2"
	    }
	  }, [_vm._v("Total")]), _vm._v(" "), _c('th', {
	    staticClass: "amount"
	  }, [_vm._v(_vm._s(_vm._f("currency")(_vm.totalMonthlyServicesAmount)))])])])], 1)]), _vm._v(" "), _c('div', {
	    staticClass: "six wide column"
	  }, [_c('table', {
	    staticClass: "ui red table"
	  }, [_vm._m(2), _vm._v(" "), _c('tbody', [_c('tr', [_c('td', [_vm._v("Project Management Ratio")]), _vm._v(" "), _c('td', {
	    staticClass: "param-input"
	  }, [_c('div', {
	    staticClass: "ui small fluid labeled input"
	  }, [_c('label', {
	    staticClass: "ui label"
	  }, [_vm._v("%")]), _vm._v(" "), _c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model.number",
	      value: (_vm.quoteParams.pmRatio),
	      expression: "quoteParams.pmRatio",
	      modifiers: {
	        "number": true
	      }
	    }],
	    attrs: {
	      "type": "text"
	    },
	    domProps: {
	      "value": _vm._s(_vm.quoteParams.pmRatio)
	    },
	    on: {
	      "change": _vm.updatePmRatio,
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.quoteParams.pmRatio = _vm._n($event.target.value)
	      },
	      "blur": function($event) {
	        _vm.$forceUpdate()
	      }
	    }
	  })])])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("Hourly Rate")]), _vm._v(" "), _c('td', {
	    staticClass: "param-input"
	  }, [_c('div', {
	    staticClass: "ui small fluid labeled input"
	  }, [_c('label', {
	    staticClass: "ui label"
	  }, [_vm._v("$")]), _vm._v(" "), _c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model.number",
	      value: (_vm.quoteParams.rate),
	      expression: "quoteParams.rate",
	      modifiers: {
	        "number": true
	      }
	    }],
	    attrs: {
	      "type": "text"
	    },
	    domProps: {
	      "value": _vm._s(_vm.quoteParams.rate)
	    },
	    on: {
	      "change": _vm.updateQuoteParams,
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.quoteParams.rate = _vm._n($event.target.value)
	      },
	      "blur": function($event) {
	        _vm.$forceUpdate()
	      }
	    }
	  })])])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("Optional Hourly Rate")]), _vm._v(" "), _c('td', {
	    staticClass: "param-input"
	  }, [_c('div', {
	    staticClass: "ui small fluid labeled input"
	  }, [_c('label', {
	    staticClass: "ui label"
	  }, [_vm._v("$")]), _vm._v(" "), _c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model.number",
	      value: (_vm.quoteParams.optionalRate),
	      expression: "quoteParams.optionalRate",
	      modifiers: {
	        "number": true
	      }
	    }],
	    attrs: {
	      "type": "text"
	    },
	    domProps: {
	      "value": _vm._s(_vm.quoteParams.optionalRate)
	    },
	    on: {
	      "change": _vm.updateOptionalRate,
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.quoteParams.optionalRate = _vm._n($event.target.value)
	      },
	      "blur": function($event) {
	        _vm.$forceUpdate()
	      }
	    }
	  })])])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("Show Monthly Recurring Services")]), _vm._v(" "), _c('td', {
	    staticClass: "param-input"
	  }, [_c('div', {
	    staticClass: "ui toggle checkbox"
	  }, [_c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.quoteParams.showHosting),
	      expression: "quoteParams.showHosting"
	    }],
	    staticClass: "hidden",
	    attrs: {
	      "type": "checkbox",
	      "tabindex": "0"
	    },
	    domProps: {
	      "checked": Array.isArray(_vm.quoteParams.showHosting) ? _vm._i(_vm.quoteParams.showHosting, null) > -1 : (_vm.quoteParams.showHosting)
	    },
	    on: {
	      "change": _vm.toggleShowHosting,
	      "click": function($event) {
	        var $$a = _vm.quoteParams.showHosting,
	          $$el = $event.target,
	          $$c = $$el.checked ? (true) : (false);
	        if (Array.isArray($$a)) {
	          var $$v = null,
	            $$i = _vm._i($$a, $$v);
	          if ($$c) {
	            $$i < 0 && (_vm.quoteParams.showHosting = $$a.concat($$v))
	          } else {
	            $$i > -1 && (_vm.quoteParams.showHosting = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
	          }
	        } else {
	          _vm.quoteParams.showHosting = $$c
	        }
	      }
	    }
	  })])])])])])])])])])
	},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('thead', [_c('tr', [_c('th'), _vm._v(" "), _c('th', {
	    attrs: {
	      "colspan": "4"
	    }
	  }, [_vm._v("Estimate Breakdown")])])])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('thead', [_c('tr', [_c('th', {
	    attrs: {
	      "colspan": "3"
	    }
	  }, [_vm._v("Monthly Recurring Services")])])])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('thead', [_c('tr', [_c('th', {
	    attrs: {
	      "colspan": "2"
	    }
	  }, [_vm._v("Estimate Parameters")])])])
	}]}

/***/ }

});


// WEBPACK FOOTER //
// static/js/app.f59431d7a4f51ad5647f.js